<div class="close-qb-oauth">
  <h1>QBO Connected Successfully</h1>
</div>
